import './images/avatar.png';
import './index.erb';
import './index.rb';
import './question_challange.erb';
import './question_tip.erb';
import './welcome.erb';
import AjaxComponentLoader from 'utils/ajax_component_loader';
import ChallengeFeedback from '../challenge_feedback';
import CookieManager from 'utils/cookie_manager';

const WELCOME_PHASE = '0';
const FILTER_PHASE = '1';
const COMMENTARY_PHASE = '2';

const ONBOARDING_OFF = 'false';

export default class OnboardingModal {
  constructor() {
    this.cookieName = 'question_challange_phase';
    this.$container = $('.js-onboarding-container');
    this.$minimizedAvatar = $(
      '.js-onboarding-minimized-avatar',
      this.$container
    );
    this.$phasesElements = $('.js-onboarding-phases', this.$container);

    this.$welcomeElement = $('.js-welcome-phase', this.$container);
    this.$filterTipElement = $('.js-filter-tip-phase', this.$container);
    this.$commentaryTipElement = $('.js-commentary-tip-phase', this.$container);
    this.$iframeElement = $('.question-challange__video-tip', this.$container);
    this.$answerChallengeBtn = $(
      '.js-question-challange-option',
      this.$container
    );
    this.$confirmAnswerBtn = $(
      '.js-question-challange-answer',
      this.$container
    );
    this.$changeAnswerBtn = $(
      '.js-question-challange-reanswer',
      this.$container
    );
    this.$endQuestionChallenge = $(
      '.js-question-challange-end',
      this.$container
    );

    this.currentQuestion = this.$container.data('question-id');
    this.$dismissButton = $('.js-onboarding-dismiss', this.$container);
    this.$agreementButton = $('.js-onboarding-agreement', this.$container);
    this.$minimizeBtn = $('.js-minimize-onboarding', this.$container);

    this.bind();
    this.show();
  }

  get onboardingPhase() {
    return CookieManager.getCookie(this.cookieName);
  }

  get currentElement() {
    const phasesElements = {
      [WELCOME_PHASE]: this.$welcomeElement,
      [FILTER_PHASE]: this.$filterTipElement,
      [COMMENTARY_PHASE]: this.$commentaryTipElement
    };

    return phasesElements[this.onboardingPhase];
  }

  setOnboardingPhase(val) {
    CookieManager.setExpirationCookie(this.cookieName, val, 1);
  }

  startOnboarding() {
    this.setOnboardingPhase(FILTER_PHASE);
    this.loadPhase();
  }

  dismissOnboarding() {
    this.$phasesElements.hide();
    this.pauseIframe();

    if (
      this.onboardingPhase === WELCOME_PHASE ||
      this.onboardingPhase === COMMENTARY_PHASE
    ) {
      this.setOnboardingPhase(false);
    }
  }

  loadPhase() {
    this.$phasesElements.hide();
    this.$minimizedAvatar.hide();
    this.pauseIframe();
    this.$minimizedAvatar.tooltip('hide');
    this.currentElement && this.currentElement.show();
  }

  pauseIframe() {
    if (this.$iframeElement.length) {
      const currentVideo = this.$iframeElement[0].src;
      this.$iframeElement[0].src = '';
      this.$iframeElement[0].src = currentVideo;
    }
  }

  handleQuestionChallengeFeedback() {
    this.dismissOnboarding();
    this.addQuestionToCookies();
    this.setOnboardingPhase(false);

    AjaxComponentLoader.load({
      component: 'questions/challenge_feedback',
      type: 'page_component',
      data: {
        answer: this.userAnswerValue,
        question: this.currentQuestion
      }
    }).then(html => {
      $('body').append(html);
      new ChallengeFeedback();
    });
  }

  addQuestionToCookies() {
    const currentValue = CookieManager.getCookie('question_challange_answered');
    const parsedArray = currentValue ? JSON.parse(currentValue) : [];

    const questionsUpdated = parsedArray
      ? [...parsedArray, this.currentQuestion]
      : [this.currentQuestion];

    CookieManager.setPersistentCookie(
      'question_challange_answered',
      JSON.stringify(questionsUpdated)
    );
  }

  minimizeWindow() {
    this.$phasesElements.hide();
    this.$minimizedAvatar.show();
  }

  show() {
    if (this.onboardingPhase === ONBOARDING_OFF) {
      return;
    }

    this.$container.show();

    if (this.onboardingPhase === WELCOME_PHASE) {
      return this.loadPhase();
    }

    this.$minimizedAvatar.show();
  }

  bind() {
    this.$dismissButton.on('click', () => this.dismissOnboarding());
    this.$agreementButton.on('click', () => this.startOnboarding());
    this.$minimizedAvatar.on('click', () => this.loadPhase());
    this.$minimizeBtn.on('click', () => this.minimizeWindow());
    this.$answerChallengeBtn?.on('click', e => {
      this.$answerChallengeBtn.removeClass('active');
      $(e.target).addClass('active');
      this.userAnswerValue = $(e.target).attr('value');
    });
    this.$confirmAnswerBtn.on('click', () => {
      this.setOnboardingPhase(COMMENTARY_PHASE);
      this.loadPhase();
    });
    this.$changeAnswerBtn.on('click', () => {
      this.setOnboardingPhase(FILTER_PHASE);
      this.loadPhase();
    });
    this.$endQuestionChallenge.on('click', () =>
      this.handleQuestionChallengeFeedback()
    );
    this.setOnboardingPhase(0);
    this.loadPhase();
  }
}
